<template>
  <create-edit-retention-policy
    :isEdit="false"
    cancelRoute="Retention policies"
  />
</template>

<script>
import CreateEditRetentionPolicy from "@/components/CreateEditRetentionPolicy";

export default {
  name: "CreateRetentionPolicy",
  components: {
    CreateEditRetentionPolicy,
  },
};
</script>
